import React, { FC, useState } from "react";
import cn from "classnames";

import { ReactComponent as PrimaryFAQIcon } from "@assets/icons/primary-faq.svg";
import { ReactComponent as GreyAccordionArrowDownIcon } from "@assets/icons/grey-accordion-arrow-down.svg";

type Props = {
	className?: string;
	title: string;
	content: string;
};

const Collapse: FC<Props> = (props) => {
	const { className, title, content } = props;

	const [expanded, setExpanded] = useState(false);

	const handleChange = () => setExpanded((previous) => !previous);

	return (
		<div className={cn(className)}>
			<button className="flex items-center pb-5 lg:pb-6 gap-x-5 w-full" onClick={handleChange}>
				<PrimaryFAQIcon />
				<div className="flex-1 text-h5 text-left">{title}</div>
				<div
					className={cn("transform transition-transform duration-200", { "rotate-180": expanded })}
				>
					<GreyAccordionArrowDownIcon />
				</div>
			</button>
			{expanded && (
				<div className="pl-[52px] pb-6 lg:pb-8 pr-4 lg:pr-8 bg-regent-gray-100 transition-all">
					<p className="text-body">{content}</p>
				</div>
			)}
		</div>
	);
};

export default Collapse;
